module.exports = __webpack_public_path__ + "img/envelope-solid.82189696.svg";